/* eslint-disable no-unused-vars */
import { QuestionCircleOutlined } from "@ant-design/icons";
import { yupResolver } from "@hookform/resolvers/yup";
import { Popconfirm, Space, Table, Tooltip } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import { AiOutlineMinusCircle } from "react-icons/ai";
import { ImCheckmark } from "react-icons/im";
import { useDispatch } from "react-redux";
import Select from "react-select";
import * as yup from "yup";
import { ReactComponent as Trash } from "../../../../assets/images/svgs/trash.svg";
import { getApiIntegrationsList } from "../../../../store/actions/manager.action";
import { ManagerService } from "../../../../utils/services/manager.service";

function Body({
  domainBrand,
  countries,
  apiTypesArray,
  currencies,
  loadingIntegrations,
  apiIntegrationDtos,
}) {
  const dispatch = useDispatch();
  const { Column } = Table;
  const formRef = useRef();
  const menuPortalTarget = document.getElementById("root");
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const [loading, setLoading] = useState(false);
  const [apiProvider, setApiProvider] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const schema = yup
    .object({
      country: yup
        .object()
        .shape({
          iso3Code: yup.string(),
          label: yup.string(),
          value: yup.string(),
        })
        .required(),
      connectorType: yup
        .object()
        .shape({
          label: yup.string(),
          value: yup.string(),
        })
        .required(),
      connectorProvider: yup
        .object()
        .shape({
          label: yup.string(),
          value: yup.string(),
        })
        .required(),
      commonName: yup.string().required(),
      extraCredentials: yup.string().required(),
      activate: yup.bool(),
      message: yup.string().notRequired(),
      apiGatewayURL: yup.string().notRequired(),
      username: yup.string().notRequired(),
      password: yup.string().notRequired(),
      api_key: yup.string().notRequired(),
      certificatePath: yup.string().notRequired(),
      currency: yup
        .object()
        .shape({
          label: yup.string(),
          value: yup.string(),
          currencyCode: yup.string(),
        })
        .notRequired(),
    })
    .required();
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const fetchApiType = async (apiType) => {
    setIsLoading(true);
    try {
      const response = await ManagerService.listApiProviders(apiType);
      if (response.status === 200) {
        const result = response?.data?.data;
        const resultArray =
          result &&
          result.map((i) => {
            return { label: i, value: i };
          });
        setApiProvider([...resultArray]);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      return [];
    }
    setIsLoading(false);
  };

  useEffect(() => {
    const watchAll = watch(async (data) => {
      if (
        data?.connectorType?.value !== undefined &&
        data?.connectorType?.value !== ""
      ) {
        await fetchApiType(data?.connectorType?.value);
      }
    });
    return () => watchAll.unsubscribe();
  }, [watch]);

  const apiTypesList = apiTypesArray.map((i) => {
    return { label: i, value: i };
  });

  const onSubmit = async (data) => {
    setLoading(true);
    let payload = {
      supportedCountry: { isoCode3: data?.country?.iso3Code },
      apiProvider: data?.connectorProvider?.value || "CRAFTYCLICKS",
      apiType: data?.connectorType?.value || "AIRTIME_TOPUP",
      apiName: data?.commonName,
      apiCredentialExtra: data?.extraCredentials,
      active: data?.activate,
      sheAccessbearer: data?.message,
    };

    if (watch("connectorType")?.value === "CURRENCY_EXCHANGE_RATE_FEED_API") {
      const CURRENCY_EXCHANGE_RATE_FEED_API = {
        apiGatewayURL: data?.apiGatewayURL,
        username: data?.username,
        password: data?.password,
      };
      payload = { ...payload, ...CURRENCY_EXCHANGE_RATE_FEED_API };
    }

    if (
      watch("connectorType")?.value === "EXTERNAL_KYC_PROVIDER" ||
      watch("connectorType")?.value === "TRANSACTION_MONITORING"
    ) {
      const EXTERNAL_KYC_PROVIDER = {
        apiGatewayURL: data?.apiGatewayURL,
        api_key: data?.api_key,
      };
      payload = { ...payload, ...EXTERNAL_KYC_PROVIDER };
    }

    if (
      watch("connectorType")?.value === "CORRESPONDENT_BANK_UTIL" ||
      watch("connectorType")?.value === "THIRD_PARTY_CARD_ISSUER"
    ) {
      const CORRESPONDENT_BANK_UTIL = {
        apiGatewayURL: data?.apiGatewayURL,
      };
      payload = { ...payload, ...CORRESPONDENT_BANK_UTIL };
    }

    if (
      watch("connectorType")?.value === "CORRESPONDENT_BANK_ACCOUNT_CREATION"
    ) {
      const CORRESPONDENT_BANK_ACCOUNT_CREATION = {
        selectedCurrency: data?.currency?.currencyCode,
        apiGatewayURL: data?.apiGatewayURL,
        username: data?.username,
        password: data?.password,
        certificatePath: data?.certificatePath,
      };
      payload = { ...payload, ...CORRESPONDENT_BANK_ACCOUNT_CREATION };
    }

    if (watch("connectorType")?.value === "SWIFT_CODE_VALIDATOR") {
      const SWIFT_CODE_VALIDATOR = {
        api_key: data?.api_key,
      };
      payload = { ...payload, ...SWIFT_CODE_VALIDATOR };
    }

    try {
      const response = await ManagerService.setUpApiConnection(payload);
      if (response.status === 200) {
        toast.success("APi connection successfully set up");
        reset({
          country: {
            iso3Code: "",
            label: "",
            value: "",
          },
          connectorType: {
            label: "",
            value: "",
          },
          connectorProvider: { label: "", value: "" },
          commonName: "",
          extraCredentials: "",
          activate: false,
          message: "",
          apiGatewayURL: "",
          username: "",
          password: "",
          api_key: "",
          certificatePath: "",
          currency: {
            label: "",
            value: "",
            currencyCode: "",
          },
        });
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  const tableData =
    apiIntegrationDtos &&
    apiIntegrationDtos?.map((i, index) => {
      return { ...i, key: index };
    });

  const activateAndDeactivateIntegration = async (apiId) => {
    setConfirmLoading(true);
    try {
      const response =
        await ManagerService.deactivateAndActivateApiIntegrations(apiId);

      if (response.status === 200) {
        toast.success(response.data.message);
        setConfirmLoading(false);
        dispatch(getApiIntegrationsList());
      }
    } catch (error) {
      setConfirmLoading(false);
      return error;
    }
    setConfirmLoading(false);
  };

  const deleteIntegration = async (apiId) => {
    setConfirmLoading(true);
    try {
      const response = await ManagerService.deleteApiIntegrations(apiId);

      if (response.status === 200) {
        toast.success(response.data.message);
        setConfirmLoading(false);
        dispatch(getApiIntegrationsList());
      }
    } catch (error) {
      setConfirmLoading(false);
      return error;
    }
    setConfirmLoading(false);
  };

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">
              {dictionary
                ? dictionary["WO_API_INTEGRATION_FOR_1322884688"]
                : "API SETUP[CURRENCY FEEDBACK, FACEBOOK/GOOGLE LOGIN ADDRESS LOOKUP]"}
            </h1>
          </div>
          <div className="ms-auto pageheader-btn" />
        </div>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12">
            {/* FORMS */}
            <div className="card overflow-hidden">
              <div className="card-body">
                <form
                  className="needs-validation"
                  onSubmit={handleSubmit(onSubmit)}
                  ref={formRef}
                >
                  <div className="form-row">
                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        {dictionary
                          ? dictionary["WO_SUPPORTED_COUNTR_1270901801"]
                          : "Supported Country"}
                        <span style={{ color: "red" }}> *</span>
                      </label>
                      <Controller
                        name="country"
                        control={control}
                        rules={{
                          required: true,
                        }}
                        render={({ field }) => {
                          return (
                            <Select
                              {...field}
                              options={countries}
                              isClearable={false}
                              isSearchable={true}
                              maxMenuHeight={250}
                              menuPlacement="bottom"
                              menuPortalTarget={menuPortalTarget}
                            />
                          );
                        }}
                      />
                    </div>

                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        {dictionary &&
                        dictionary["WO_CONNECTOR_PROVIDE_-366790856"] !==
                          undefined
                          ? dictionary["WO_CONNECTOR_PROVIDE_-366790856"]
                          : "Connector Provider"}
                      </label>
                      <Controller
                        name="connectorProvider"
                        control={control}
                        rules={{
                          required: true,
                        }}
                        render={({ field }) => {
                          return (
                            <Select
                              {...field}
                              options={apiProvider}
                              isClearable={true}
                              isSearchable={true}
                              maxMenuHeight={250}
                              menuPlacement="bottom"
                              menuPortalTarget={menuPortalTarget}
                              isLoading={isLoading}
                            />
                          );
                        }}
                      />
                    </div>

                    {/* FROM HERE */}
                    {watch("connectorType")?.value ===
                      "CURRENCY_EXCHANGE_RATE_FEED_API" && (
                      <>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["para_gateway_url"] !== undefined
                              ? dictionary["para_gateway_url"]
                              : "Gateway URL"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="apiGatewayURL"
                            {...register("apiGatewayURL", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary && dictionary["l_loginId"] !== undefined
                              ? dictionary["l_loginId"]
                              : "Login ID/User ID/Username"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="username"
                            {...register("username", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["WO_PASSWOR_-1150637439"] !== undefined
                              ? dictionary["WO_PASSWOR_-1150637439"]
                              : "Password"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="password"
                            {...register("password", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                      </>
                    )}

                    {watch("connectorType")?.value ===
                      "TRANSACTION_MONITORING" ||
                    watch("connectorType")?.value ===
                      "EXTERNAL_KYC_PROVIDER" ? (
                      <>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["para_gateway_url"] !== undefined
                              ? dictionary["para_gateway_url"]
                              : "Gateway URL"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="apiGatewayURL"
                            {...register("apiGatewayURL", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary[" WO_CONNECTOR_KE_2131594297"] !==
                              undefined
                              ? dictionary[" WO_CONNECTOR_KE_2131594297"]
                              : "Connector Key"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="api_key"
                            {...register("api_key", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    {watch("connectorType")?.value ===
                      "CORRESPONDENT_BANK_UTIL" ||
                    watch("connectorType")?.value ===
                      "THIRD_PARTY_CARD_ISSUER" ? (
                      <div className="col-md-6 col-lg-6 mb-3">
                        <label>
                          {dictionary &&
                          dictionary["para_gateway_url"] !== undefined
                            ? dictionary["para_gateway_url"]
                            : "Gateway URL"}
                        </label>
                        <input
                          type={"text"}
                          className="form-control border px-3"
                          name="apiGatewayURL"
                          {...register("apiGatewayURL", {
                            required: {
                              value: true,
                              message: "This field is required",
                            },
                          })}
                        />
                      </div>
                    ) : (
                      ""
                    )}

                    {watch("connectorType")?.value ===
                      "CORRESPONDENT_BANK_ACCOUNT_CREATION" && (
                      <>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["WO_CURRENCY_1471979772"] !== undefined
                              ? dictionary["WO_CURRENCY_1471979772"]
                              : "Currency"}
                          </label>
                          <Controller
                            name="currency"
                            control={control}
                            rules={{
                              required: true,
                            }}
                            render={({ field }) => {
                              return (
                                <Select
                                  {...field}
                                  options={currencies}
                                  isClearable={true}
                                  isSearchable={true}
                                  maxMenuHeight={250}
                                  menuPlacement="bottom"
                                  menuPortalTarget={menuPortalTarget}
                                  isLoading={isLoading}
                                />
                              );
                            }}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["para_gateway_url"] !== undefined
                              ? dictionary["para_gateway_url"]
                              : "Gateway URL"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="apiGatewayURL"
                            {...register("apiGatewayURL", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary && dictionary["l_loginId"] !== undefined
                              ? dictionary["l_loginId"]
                              : "Login ID/User ID/Username"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="username"
                            {...register("username", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["WO_PASSWOR_-1150637439"] !== undefined
                              ? dictionary["WO_PASSWOR_-1150637439"]
                              : "Password"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="password"
                            {...register("password", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["WO_CERTIFICATE_PAT_-1245553379"] !==
                              undefined
                              ? dictionary["WO_CERTIFICATE_PAT_-1245553379"]
                              : "Certificate Path"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="certificatePath"
                            {...register("certificatePath", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                      </>
                    )}

                    {watch("connectorType")?.value ===
                    "SWIFT_CODE_VALIDATOR" ? (
                      <>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary[" WO_CONNECTOR_KE_2131594297"] !==
                              undefined
                              ? dictionary[" WO_CONNECTOR_KE_2131594297"]
                              : "Connector Key"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="api_key"
                            {...register("api_key", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        {dictionary &&
                        dictionary["WO_CONNECTOR_TYP_1350994000"] !== undefined
                          ? dictionary["WO_CONNECTOR_TYP_1350994000"]
                          : "Connector Type"}
                        <span style={{ color: "red" }}> *</span>
                      </label>
                      <Controller
                        name="connectorType"
                        control={control}
                        rules={{
                          required: true,
                        }}
                        render={({ field }) => {
                          return (
                            <Select
                              {...field}
                              options={apiTypesList}
                              isClearable={false}
                              isSearchable={true}
                              maxMenuHeight={250}
                              menuPlacement="bottom"
                              menuPortalTarget={menuPortalTarget}
                            />
                          );
                        }}
                      />
                    </div>

                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        {dictionary &&
                        dictionary["WO_CONNECTORS_518784763"] !== undefined
                          ? dictionary["WO_CONNECTORS_518784763"]
                          : "Connector(s)"}
                        <span style={{ color: "red" }}> *</span>
                      </label>
                      <input
                        type={"text"}
                        className="form-control border px-3"
                        name="commonName"
                        {...register("commonName", {
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        })}
                      />
                    </div>

                    <div className="col-md-6 col-lg-6 mb-3">
                      <>
                        <label>
                          {dictionary
                            ? dictionary["WO_EXTRA_CREDENTIAL_-1760386648"]
                            : "Extra Credentials"}
                          <span style={{ color: "red" }}> *</span>
                        </label>
                        <input
                          type={"text"}
                          className="form-control border px-3"
                          name="extraCredentials"
                          {...register("extraCredentials", {
                            required: {
                              value: true,
                              message: "This field is required",
                            },
                          })}
                        />
                      </>
                      <div className="form-row m-0">
                        <label className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            defaultChecked={false}
                            {...register("activate", {})}
                            // onChange={toggleCheckBox}
                          />
                          <span className="custom-control-label pointer fs-12">
                            <span>
                              {" "}
                              {dictionary
                                ? dictionary["para_activate_no_capital"]
                                : "Activate"}
                            </span>
                          </span>
                        </label>
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        System Bearer (copy & paste: This value will be provided
                        by MTA.)
                        {/* {dictionary
                          ? dictionary["WO_PRODUCT_DESCRIPTIO_-997141829"]
                          : "System Bearer (copy & paste: This value will be provided by MTA. )"} */}
                        {/* <span style={{ color: "red" }}> *</span> */}
                      </label>
                      <textarea
                        className="form-control border px-3"
                        name="message"
                        {...register("message", {
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        })}
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="col-lg-6 col-md-6 mb-3" />
                    <div className="col-lg-6 col-md-6 mb-3">
                      <button
                        className="btn btn-primary margin-label width-100 fw-bold"
                        type="submit"
                      >
                        {dictionary
                          ? dictionary["WO_UPDAT_1172718133"]
                          : "UPDATE"}
                        {loading && (
                          <>
                            &nbsp;
                            <i className="fa fa-spinner fa-spin" />
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* TABLES */}
          <div className="col-lg-12 col-md-12">
            <div className="card overflow-hidden">
              <div className="card-header bg-primary text-white">
                <h3 className="card-title">
                  {/* {dictionary ? dictionary["button_add_new"] : "APIs"} */}
                  API(S)
                </h3>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <Table
                    dataSource={tableData}
                    className="w-100 table tbody"
                    loading={loadingIntegrations}
                  >
                    <Column
                      title="Feed Name"
                      dataIndex="username"
                      key="1"
                      className=""
                    />
                    <Column
                      title="Connector(s)"
                      dataIndex="apiName"
                      key="2"
                      className=""
                    />
                    <Column
                      title="Connector Type"
                      dataIndex="apiType"
                      key="1"
                      className=""
                    />
                    <Column
                      title="API Provider"
                      dataIndex="apiProvider"
                      key="1"
                      className=""
                    />
                    <Column
                      title="Supported Country"
                      dataIndex="supportedCountry"
                      key="1"
                      className=""
                    />
                    <Column
                      title="Status"
                      dataIndex="active"
                      key="1"
                      className=""
                      render={(text) => {
                        return <span>{text ? "true" : "false"}</span>;
                      }}
                    />
                    <Column
                      title="Action"
                      dataIndex=""
                      key="1"
                      className=""
                      render={(text, record) => {
                        return (
                          <Space size="small">
                            <>
                              {record.active && (
                                <Popconfirm
                                  title={`Deactivate ${record.apiProvider}`}
                                  description="Are you sure to deactivate this API Provider?"
                                  icon={
                                    <QuestionCircleOutlined
                                      style={{ color: "red" }}
                                    />
                                  }
                                  onConfirm={() =>
                                    activateAndDeactivateIntegration(record.id)
                                  }
                                  okButtonProps={{
                                    loading: confirmLoading,
                                  }}
                                  onCancel={() => {
                                    setConfirmLoading(false);
                                  }}
                                >
                                  <Tooltip
                                    title={`Deactivate ${record.apiProvider}`}
                                    color="#212529"
                                    placement="bottom"
                                    arrowPointAtCenter={true}
                                  >
                                    <AiOutlineMinusCircle
                                      color={"#6259CA"}
                                      fontSize={20}
                                      fill={"#6259CA"}
                                      className="cursor-pointer"
                                    />
                                  </Tooltip>
                                </Popconfirm>
                              )}
                            </>

                            <>
                              {!record.active && (
                                <Popconfirm
                                  title={`Activate ${record.apiProvider}`}
                                  description="Are you sure to activate this API Provider?"
                                  icon={
                                    <QuestionCircleOutlined
                                      style={{ color: "red" }}
                                    />
                                  }
                                  onConfirm={() =>
                                    activateAndDeactivateIntegration(record.id)
                                  }
                                  okButtonProps={{
                                    loading: confirmLoading,
                                  }}
                                  onCancel={() => {
                                    setConfirmLoading(false);
                                  }}
                                >
                                  <Tooltip
                                    title={`Activate ${record.apiProvider}`}
                                    color="#212529"
                                    placement="bottom"
                                    arrowPointAtCenter={true}
                                  >
                                    <ImCheckmark
                                      color={"#6259CA"}
                                      fontSize={20}
                                      fill={"#6259CA"}
                                      className="cursor-pointer"
                                    />
                                  </Tooltip>
                                </Popconfirm>
                              )}
                            </>

                            <Popconfirm
                              title={`Delete ${record.apiProvider}`}
                              description="Are you sure to delete this API Provider?"
                              icon={
                                <QuestionCircleOutlined
                                  style={{ color: "red" }}
                                />
                              }
                              onConfirm={() => deleteIntegration(record.id)}
                              okButtonProps={{
                                loading: confirmLoading,
                              }}
                              onCancel={() => {
                                setConfirmLoading(false);
                              }}
                            >
                              <Tooltip
                                title={`Delete ${record.apiProvider}`}
                                color="#212529"
                                placement="bottom"
                                arrowPointAtCenter={true}
                              >
                                <Trash
                                  className="cursor-pointer"
                                  style={{ height: "20px" }}
                                />
                              </Tooltip>
                            </Popconfirm>
                          </Space>
                        );
                      }}
                    />
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Body;
